<!--
 * @Author: LXG
 * @Date: 2021-04-27
 * @Editors: LXG
 * @LastEditTime: 2021-06-15
 * @Description: 政策项目申报 - 经办人信息
-->
<template>
    <div class="personal">
        <h2 class="p-title">联系人基本信息</h2>
        <div>
            <el-form
                ref="form"
                :model="cpu_value"
                size="medium"
                label-width="100px"
                :rules="formRules"
            >
                <el-form-item
                    prop="agentname"
                    label="联系人姓名"
                >
                    <FormInput
                        v-model="cpu_value.agentname"
                        :disabled="disabled"
                    ></FormInput>
                </el-form-item>
                <el-form-item
                    prop="agentcertificatenumber"
                    label="证件号码"
                >
                    <FormInput
                        v-model="cpu_value.agentcertificatenumber"
                        placeholder=" "
                        :disabled="disabled"
                    >
                        <template v-slot:prepend>
                            <span>身份证</span>
                        </template>
                    </FormInput>
                </el-form-item>
                <el-form-item
                    prop="agentmobilephone"
                    label="联系电话"
                >
                    <FormInput
                        v-model.number="cpu_value.agentmobilephone"
                        :disabled="disabled"
                    ></FormInput>
                </el-form-item>
                <el-form-item
                    prop="agentaddress"
                    label="联系地址"
                >
                    <FormInput
                        v-model="cpu_value.agentaddress"
                        placeholder=" "
                        :disabled="disabled"
                    ></FormInput>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { FormInput } from '@/components/form/index.js'
import { checkIdcard, checkPhone } from '@/utils/check.js'

export default {
    name: 'Personal',
    components: {
        FormInput,
    },
    props: {
        value: {},
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            formRules: {
                agentname: [
                    { required: true, message: '请输入经办人姓名', trigger: 'blur' }
                ],
                agentcertificatenumber: [
                    { required: true, message: '请输入身份证号码', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (!checkIdcard(value)) {
                                callback(new Error('请输入正确的身份证号码'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    },
                     {
                        required: true,
                        message: "请输入正确的身份证号码",
                        trigger: "blur",
                        pattern:
                           /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                     },
                ],
                agentmobilephone: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (!checkPhone(value)) {
                                callback(new Error('请输入正确的手机号码'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
            },
        }
    },
    computed: {
        cpu_value: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.p-title {
    color: #000000;
    padding-bottom: 5px;
    padding-left: 10px;
    border-bottom: 4px solid #000000;
    margin-bottom: 10px;
}
</style>
